<template>
  <div ref="list" class="list-group list-group-bordered">
    <div v-if="showHeader"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }"
         class="list-group-header d-flex align-items-center">
        <span :class="{ 'mb-2': extraSmall || small }">
          {{ financingCommitments.length }} {{ financingCommitments.length === 1 ? 'compromiso' : 'compromisos' }} agregados</span>
      <div :class="{ 'ml-auto': !extraSmall && !small }">
        <div class="d-inline-block" v-if="editable">
          <button class="btn btn-light"
                  title="Agregar compromiso"
                  type="button"
                  @click="$emit('add-financing-commitment')">
            <i class="fas fa-user-plus mr-2"></i> Agregar compromiso
          </button>
        </div>
      </div>
    </div>
    <div v-if="financingCommitments && financingCommitments.length">
      <div v-for="(financing, key) in financingCommitments"
           :key="financing.financing_commitment_id"
           :data-id="financing.financing_commitment_id"
           class="list-group-item">
        <div class="list-group-item-body">
          <div class="row">
            <div class="col">
              <h6 class="font-weight-bold">
                {{ financing.funder_title }} (${{ financing.budget }})
                
                <span :class="getTagClass(financing.financing_commitment_status_title)"
                      class="badge text-sm" style="font-size: 0.75rem">{{
                    financing.financing_commitment_status_title
                                                                       }}</span>
              </h6>
              <p class="list-group-item-text mb-2 text-black">
                {{ financing.commitment_made }}
              </p>
              <p class="list-group-item-text mb-2">
                Fecha de cumplimiento: {{ financing.compliance_date }}
              </p>
              
              
            </div>
            
            <div class="col-md-12" v-if="editing">
              <h3 class="list-group-item-title font-weight-bold mt-1 mb-1">
                Detalles
              </h3>
              <div class="list-group list-group-flush list-group-divider">
                <div class="list-group-item" v-for="(overdueCommitment, key) in financing.overdue_commitments" :key="key">
                  <div class="list-group-item-body">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <h4 class="list-group-item-title">
                          Nueva fecha de cumplimiento:
                        </h4>
                        <p class="list-group-item-text mb-1">
                          {{ overdueCommitment.compliance_date }}
                        </p>
                        <h4 class="list-group-item-title">
                          Fecha de registro:
                        </h4>
                        <p class="list-group-item-text mb-1">
                          {{ overdueCommitment.reply_record_date }}
                        </p>
                        <h4 class="list-group-item-title">
                          Estado:
                        </h4>
                        <p class="list-group-item-text mb-1">
                          {{ overdueCommitment.status }}
                        </p>
                        <div class="commitment-radio">
                          <h4 class="list-group-item-title font-weight-bold" v-if="editing">
                            ¿Se cumplió?
                          </h4>
                          <div class="form-check form-check-inline" v-if="editing">
                            <input :id="`complete_true_${overdueCommitment.id + '' + overdueCommitment.index}`"
                                  :checked="overdueCommitment.commitment_fulfilled === true"
                                  :disabled="overdueCommitment.commitment_fulfilled !== null || financing.financing_commitment_status_key === 'proceso_eliminacion'"
                                  :name="'commitment-status-' + overdueCommitment.id + '' + overdueCommitment.index"
                                  class="form-check-input"
                                  type="radio"
                                  value="1"
                                  :data-commitment-id="overdueCommitment.id + '' + overdueCommitment.index"
                                  @click="changeCommitmentStatus(true, financing.financing_commitment_id, financing.type, overdueCommitment.id + '' + overdueCommitment.index)">
                            <label class="form-check-label font-weight-normal"
                                  :for="`complete_true_${overdueCommitment.id + '' + overdueCommitment.index}`">Sí</label>
                          </div>
                          
                          <div class="form-check form-check-inline" v-if="editing">
                            <input :id="'complete_false_' + overdueCommitment.id + '' + overdueCommitment.index"
                                  :checked="overdueCommitment.commitment_fulfilled === false"
                                  :disabled="overdueCommitment.commitment_fulfilled !== null || financing.financing_commitment_status_key === 'proceso_eliminacion'"
                                  :name="'commitment-status-' + overdueCommitment.id + '' + overdueCommitment.index"
                                  class="form-check-input"
                                  type="radio"
                                  value="0"
                                  :data-commitment-id="overdueCommitment.id + '' + overdueCommitment.index"
                                  @click="changeCommitmentStatus(false, financing.financing_commitment_id, financing.type, overdueCommitment.id + '' + overdueCommitment.index)">
                            <label class="form-check-label font-weight-normal"
                                  :for="`complete_false_${overdueCommitment.id + '' + overdueCommitment.index}`">No</label>
                          </div>
                          <div class="custom-error-message"></div>
                        </div>
                        
                        <div id="uploadList"
                             class="list-group d-none list-group-flush list-group-divider d-flex"
                             v-if="overdueCommitment.vouchers">
                          <div class="list-group-item border-0"
                               v-for="(voucher, key) in overdueCommitment.vouchers"
                               :key="key">
                              <div class="list-group-item-figure pl-0 py-1">
                                <div class="tile tile-img">
                                  <span class="fas fa-file-pdf fa-lg text-red"></span>
                                </div>
                              </div>
                              <div class="list-group-item-body border-0 py-1">
                                <div class="media align-items-center">
                                  <div class="media-body">
                                    <a :download="voucher.file_name" :href="`/${voucher.file_path}`" target="_blank">
                                      {{ voucher.file_name }}
                                    </a>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                        
                      </div>
                      <div class="media-actions mb-auto"
                           v-if="overdueCommitment.commitment_fulfilled !== null">
                        <div class="list-group-item-figure align-items-start">
                          <div class="dropdown">
                            <button class="btn btn-sm btn-icon btn-light"
                                    data-toggle="dropdown">
                              <i class="fa fa-fw fa-ellipsis-v"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <div class="dropdown-arrow mr-n1"></div>
                              <button ref="btn-resend-invitation"
                                      @click="showMessageModal(
                                        overdueCommitment.commitment_fulfilled ? overdueCommitment.comments : overdueCommitment.justification,
                                        overdueCommitment.commitment_fulfilled
                                      )"
                                      class="dropdown-item"
                                      type="button">Ver comentarios
                              </button>
                              <button ref="btn-resend-invitation"
                                      v-if="overdueCommitment.editable && financing.financing_commitment_status_key !== 'proceso_eliminacion'"
                                      class="dropdown-item"
                                      type="button"
                                      @click="editCommitmentStatus(overdueCommitment.commitment_fulfilled, overdueCommitment, financing.type)">Editar compromiso
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="showActions && editable && financing.financing_commitment_status_key !== 'proceso_eliminacion'" class="list-group-item-figure align-items-start">
          <button ref="btn-resend-invitation"
                  class="btn btn-secondary mr-2"
                  type="button"
                  @click="$emit('edit-commitment', financing)"
                  v-if="((protocol && protocol.status.key === 'reg') || (amendment && amendment.status.key === 'registrada')) && editableCommitments">Editar
          </button>

          <button ref="btn-resend-invitation"
                  class="btn btn-secondary"
                  type="button"
                  @click="$emit('request-remove-commitment', financing)"
                  v-if="((protocol && protocol.status.key !== 'reg')) && editable">Enviar solicitud para eliminar
          </button>

          <button ref="btn-resend-invitation"
                  class="btn btn-secondary"
                  type="button"
                  @click="$emit('remove-commitment', financing.financing_commitment_id)"
                  v-else>Eliminar
          </button>
        </div>
      </div>
    </div>
    
    <portal to="commitments-modals">
      <financing-commitment-status-modal id="financing-commitments-status-modal"
                                         ref="financingCommitmentsStatusModal"
                                         :complete-status="completeStatus"
                                         :financing-commitment-id="financingCommitmentId"
                                         :type="type"
                                         :selected-radio-data="selectedRadioData"
                                         :protocol="protocol"
                                         :amendment="amendment"></financing-commitment-status-modal>
      <message-modal id="message-modal"
                    ref="message-modal"
                    :title="modalTitle"
                    :message="modalMessage"></message-modal>
    </portal>
  </div>
</template>

<script>
  import FinancingCommitmentStatusModal from './FinancingCommitmentStatusModal'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import MessageModal from '../ui/MessageModal'
  
  export default {
    name: 'FinancingCommitmentsList',
    components: {
      FinancingCommitmentStatusModal,
      OkCancelDialog,
      MessageModal,
    },
    props: {
      financingCommitments: {
        type: Array,
        default: () => ([]),
      },
      protocol: {
        type: Object,
        default: null,
      },
      amendment: {
        type: Object,
        default: null,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showActions: {
        type: Boolean,
        default: true,
      },
      editing: {
        type: Boolean,
        default: false,
      },
      editable: {
        type: Boolean,
        default: true,
      },
      editableCommitments: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        completeStatus: null,
        financingCommitmentId: null,
        type: null,
        selectedRadioData: null,
        modalTitle: null,
        modalMessage: null,
      }
    },
    methods: {
      changeCommitmentStatus (selectedStatus, financingCommitmentId, type, selectedRadioData) {
        this.completeStatus        = selectedStatus
        this.financingCommitmentId = financingCommitmentId
        this.type                  = type
        this.selectedRadioData     = selectedRadioData

        this.$refs.financingCommitmentsStatusModal.showModal()
      },
      editCommitmentStatus (completeStatus, overdueCommitment, type) {
        this.completeStatus        = completeStatus
        this.financingCommitmentId = overdueCommitment.commitment_id
        this.type                  = type

        this.$refs.financingCommitmentsStatusModal.showModal(overdueCommitment)
      },
      getTagClass (statusKey) {
        const titleStatuses = {
          Registrado: 'badge-primary',
          Cumplido: 'badge-success',
          Recalendarizado: 'badge-warning',
          Incumplido: 'badge-subtle badge-danger',
          default: 'badge-subtle badge-dark',
        }
        
        if (statusKey in titleStatuses) {
          return titleStatuses[statusKey]
        }
        
        return titleStatuses.default
      },
      showMessageModal (justification, fulfilled) {
        if (fulfilled) {
          this.modalTitle   = 'Comentarios de compromiso cunplido'
        } else {
          this.modalTitle   = 'Justificación de compromiso no cumplido'
        }
        
        this.modalMessage = justification

        $('#message-modal').modal('show')
      },
    },
    computed: {
      extraSmall () {
        return this.$mq === 'xs'
      },
      small () {
        return this.$mq === 'sm'
      },
    },
    mounted () {
    
    },
  }
</script>
